
// 西药 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  码上放心
 *  
 */
// 根据根据追溯码查询药品信息
export const msfxCodeDetail = (data) => {
    return request.post("/outpatient/msfx/codeDetail", data)
}
// 信息-根据企业名称或证号查询企业信息列表
export const msfxGetEntInfoList = (data) => {
    return request.post("/outpatient/msfx/getEntInfoList", data)
}
// 上游出库单单据明细查询
export const msfListUpoutDetail = (data) => {
    return request.post("/outpatient/msfx/listUpoutDetail", data)
}
// 出入库单据上传
export const msfxUploadInoutBill = (data) => {
    return request.post("/outpatient/msfx/uploadInoutBill", data)
}
// 零售单据上传接口
export const msfxUploadRetail = (data) => {
    return request.post("/outpatient/msfx/uploadRetail", data)
}

// 用于新建采购计划或入库订单扫描追溯码查询药品
export const getSomeWare = (params) => {
	return request.get("/outpatient/getWareBar", {params})
}
// 西药通过药品id和厂家批准文号，查询生产厂家和有效日期天数信息
export const getCJSomeWare = (params) => {
	return request.get("/outpatient/getWareCjBar", {params})
}

// 核验追溯码数量
export const barcodeCheckBar = (data) => {
	return request.post("/outpatient/barcode/checkBar", data)
}

// 查询追溯码信息 
export const selBar = (params) => {
    return request.get("/outpatient/barcode/selBar", {params})
}

// 筛选剔除已上传的追溯码
export const barcodeScreen = (data) => {
	return request.post("/outpatient/barcode/screen", data)
}

/**
 * 
 *  post
 *  
 */
// 西药库盘点-草稿录入
export const pdsk = (data) => {
    return request.post("/outpatient/sk", data)
}
// 西药房盘点-草稿录入
export const WesternPdsk = (data) => {
    return request.post("/outpatient/phar", data)
}

// 新增西药品调拨
export const Adddpurcallocate = (data) => {
    return request.post("/outpatient/dpurcallocate/addAllocate", data)
}
// 新增中药品调拨
export const AddZYdpurcallocate = (data) => {
    return request.post("/outpatient/dpurctcmallocate/addTcmAllocate", data)
}
// 新建 调拨和退药，选择药品
export const selectDrug = (params) => {
    return request.get("/outpatient/docOut/selectDrug", { params })
}
// 西药品调拨单-修改
export const editdpurcallocate = (data) => {
    return request.post("/outpatient/dpurcallocate/editAllocate", data)
}
// zhong药品调拨单-修改
export const ZYeditdpurcallocate = (data) => {
    return request.post("/outpatient/dpurctcmallocate/editTcmAllocate", data)
}
// 新增西药库存盘点
export const skInsert = (data) => {
    return request.post("/outpatient/sk/insert", data)
}

// 西药调拨单 = > 快速调拨
export const fastTransfer = (params) => {
    return request.get("/outpatient/dpurcallocate/fastTransfer", {params})
}
// 中药调拨单 = > 快速调拨
export const ZYfastTransfer = (params) => {
    return request.get("/outpatient/dpurctcmallocate/fastTransfer", {params})
}
// 西药品调拨单_修改状态状态
export const changedpurcallocate = (data) => {
    return request.post("/outpatient/dpurcallocate/change", data)
}
// zhon药品调拨单_修改状态状态
export const ZYchangedpurcallocate = (data) => {
    return request.post("/outpatient/dpurctcmallocate/change", data)
}


// 西药房出库_分页
export const XYdugRetnPage = (params) => {
	return request.get("/outpatient/dugRetn/page", {params})
}
// 中药房出库_分页
export const ZYdugRetnPage = (params) => {
	return request.get("/outpatient/tcmRetn/page", {params})
}
// 西药房出库_选择要出库的药品
export const XYFselectDrug = (params) => {
	return request.get("/outpatient/dugRetn/selectRetnDrug", {params})
}
// 中药房出库_选择要出库的药品
export const ZYFselectDrug = (params) => {
	return request.get("/outpatient/tcmRetn/selectTcmList", {params})
}
// 西药房出库_点击加入
export const XYFdugRetnJoin = (params) => {
	return request.get("/outpatient/dugRetn/join", {params})
}
// 中药房出库_点击加入
export const ZYFdugRetnJoin = (params) => {
	return request.get("/outpatient/tcmRetn/join", {params})
}
// 西药房出库_详情
export const XYFgetDrugRetnList = (params) => {
	return request.get("/outpatient/dugRetn/getDrugRetnList", {params})
}
// 中药房出库_详情
export const ZYFgetDrugRetnList = (params) => {
	return request.get("/outpatient/tcmRetn/getTcmRetnList", {params})
}
// 西药房出库_出库方式
export const dugRetnWays = (params) => {
	return request.get("/outpatient/dugRetn/selectOut", {params})
}
// 西药房出库_出库方式
export const ZYFdugRetnWays = (params) => {
	return request.get("/outpatient/tcmRetn/selectOut", {params})
}

// 西药房出库 新建一条西药房出库单
export const XYFAddReturn = (data) => {
    return request.post("/outpatient/dugRetn/insert", data)
}
// 中药房出库 新建一条西药房出库单
export const ZYFAddReturn = (data) => {
    return request.post("/outpatient/tcmRetn/addTcmDrugRetn", data)
}
// 西药房出库 修改一条西药房出库单
export const XYFEditReturn = (data) => {
    return request.post("/outpatient/dugRetn/edit", data)
}
// 中药房出库 修改一条中药房出库单
export const ZYFEditReturn = (data) => {
    return request.post("/outpatient/tcmRetn/editTcmDrugRetn", data)
}
// 西药房出库 状态变更
export const XYFtoExamine = (data) => {
    return request.post("/outpatient/dugRetn/toExamine", data)
}
// 中药房出库 状态变更
export const ZYFtoExamine = (data) => {
    return request.post("/outpatient/tcmRetn/toExamine", data)
}
// 西药房出库_删除
export const XYFdeleteRetn = (params) => {
    return request.delete("/outpatient/dugRetn/deleteRetn", { params })
}
// 中药房出库_删除
export const ZYFdeleteRetn = (params) => {
    return request.delete("/outpatient/tcmRetn/deleteRetn", { params })
}
/**
 * 
 * get 
 *  
 */

// 西药库盘点-提交-审核
export const skCheck = (params) => {
    return request.get("/outpatient/sk/check", { params })
}

// 西药房盘点-提交-审核
export const pharskCheck = (params) => {
    return request.get("/outpatient/phar/check", { params })
}

// 西药库盘点列表-分页
export const skPage = (params) => {
    return request.get("/outpatient/sk/page", { params })
}
// 西药房盘点列表-分页
export const pharPage = (params) => {
    return request.get("/outpatient/phar/page", { params })
}
// 西药库盘点点击查看或者草稿操作
export const getSkVo = (params) => {
    return request.get("/outpatient/sk/getSkVo", { params })
}
// 西药房盘点点击查看或者草稿操作
export const getDrugSkVo = (params) => {
    return request.get("/outpatient/phar/getDrugSkVo", { params })
}



// 西药品调拨单-分页
export const dpurcallocatePage = (params) => {
    return request.get("/outpatient/dpurcallocate/page", { params })
}

// 中药品调拨单-分页
export const ZYdpurcallocatePage = (params) => {
    return request.get("/outpatient/dpurctcmallocate/page", { params })
}

// 西药品调拨单-信息
export const getdpurcallocate = (params) => {
    return request.get("/outpatient/dpurcallocate/getAllocateDetail", { params })
}
// zhon 药品调拨单-信息
export const getZYdpurcallocate = (params) => {
    return request.get("/outpatient/dpurctcmallocate/get", { params })
}

// 西药调拨单 = > 加入
export const dpurcallocateJoin = (params) => {
    return request.get("/outpatient/dpurcallocate/join", {params})
}
// zhon药调拨单 = > 加入
export const ZYdpurcallocateJoin = (params) => {
    return request.get("/outpatient/dpurctcmallocate/join", {params})
}

/**
 * 
 * DELETE 
 *  
 */

// 西药品调拨单_删除
export const Canceldpurcallocate = (params) => {
    return request.delete("/outpatient/dpurcallocate/cancel", { params })
}
// 中药药品调拨单_删除
export const ZYCanceldpurcallocate = (params) => {
    return request.get("/outpatient/dpurctcmallocate/cancel", { params })
}
// 西药库盘点_删除
export const deleteSk = (params) => {
    return request.get("/outpatient/sk/deleteSk", { params })
}

/*
	Others
*/

// 获取厂家信息
export const getManufacturer = (params) => {
    return request.get("/outpatient/getManufacturer", { params })
}
// 供应商下拉列表
export const selectDropDownList = (params) => {
    return request.get("/outpatient/selectDropDownList", { params })
}
// 获取药品加成率 => 西药
export const getDocMark = (params) => {
    return request.get("/outpatient/docMark/page", { params })
}
// 西药库存列表
export const PurctcmtableList = (params) => {
    return request.get("/outpatient/dpurcallocate/list", { params })
}
// 西药退库详情页
export const getRetnList = (params) => {
    return request.get("/outpatient/purcRetn/getRetnList", {params})
}
// 查询所有科室列表
export const findAttribute = (params) => {
    return request.get("/outpatient/findAttribute", {params})
}

// 西药Excel导入接口
export const importExcel = (formData) => {
    return request.post("/outpatient/import", formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        transformRequest: [data => data] // 禁用axios的默认转换
    })
}

// 西药房Excel导入接口
export const XYFimportExcel = (formData) => {
    return request.post("/outpatient/dugDoc/import", formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        transformRequest: [data => data] // 禁用axios的默认转换
    })
}

// 中药Excel导入接口
export const importZYExcel = (formData) => {
    return request.post("/outpatient/purctcmdoc/import", formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        transformRequest: [data => data] // 禁用axios的默认转换
    })
}
// 中药房Excel导入接口
export const ZYFimportExcel = (formData) => {
    return request.post("/outpatient/tcmDoc/import", formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        transformRequest: [data => data] // 禁用axios的默认转换
    })
}

// 暴露
export default{
	// 西药采购计划
	
	// 西药采购入库
	
	// 西药采购退库
	
	// 西药库存列表
	PurctcmtableList,
	
	// 西药药品调拨
	Adddpurcallocate,editdpurcallocate,changedpurcallocate,selectDrug,
	dpurcallocatePage,Canceldpurcallocate,getdpurcallocate,dpurcallocateJoin,fastTransfer,
	// 西药库盘点
	skInsert,getSkVo,skPage,pdsk,skCheck,deleteSk,
	// 西药房盘点
	pharPage,getDrugSkVo,WesternPdsk,pharskCheck,
	// others
	getManufacturer,getDocMark,findAttribute,
	selectDropDownList,importExcel
}